import * as S from "./moreDetailTemplates.style";
import { MoreDetailHeader } from "../../molcules/Header";

interface MainProps {
  pageTitle?: string;
  isBack?: boolean;
  f7router?: any;
  children: React.ReactElement;
}

export const MoreDetailTemplates = ({
  pageTitle,
  isBack,
  children,
}: MainProps) => {
  return (
    <S.MainTemplates>
      <S.ContentNavigation>
        <MoreDetailHeader pageTitle={pageTitle} isBack={isBack} />
      </S.ContentNavigation>
      <S.ContentsSection>{children}</S.ContentsSection>
    </S.MainTemplates>
  );
};
